var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReportIcon = function SvgReportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 38.5h10.5C35 38.5 38.5 35 38.5 26.25v-10.5C38.5 7 35 3.5 26.25 3.5h-10.5C7 3.5 3.5 7 3.5 15.75v10.5C3.5 35 7 38.5 15.75 38.5Z",
    stroke: "currentcolor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 32.375a3.51 3.51 0 0 0 3.5-3.5v-15.75a3.51 3.51 0 0 0-3.5-3.5 3.51 3.51 0 0 0-3.5 3.5v15.75c0 1.925 1.558 3.5 3.5 3.5ZM14.875 32.375a3.51 3.51 0 0 0 3.5-3.5V22.75a3.51 3.51 0 0 0-3.5-3.5 3.51 3.51 0 0 0-3.5 3.5v6.125c0 1.925 1.557 3.5 3.5 3.5Z",
    stroke: "currentcolor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgReportIcon;